import { SafeHtml } from "~/hec/components/atoms/safe-html/safe-html";
import { cn } from "~/lib/ui";

import type { ClaimResponseMessageProps } from "./types";

/**
 * Molecule: the server's reply under the Claim button
 * (SFRA `.c-loyalty-form__response-message`: 12px, 15px above, inherits the
 * card colour). Rendered in flow rather than absolutely positioned so a long
 * message grows the card instead of overflowing it. Links are underlined for
 * accessibility — SFRA's scope rule hid them, which left "Sign in" invisible.
 */
export function ClaimResponseMessage({
  tone,
  message,
  format,
  className,
  ...rest
}: ClaimResponseMessageProps) {
  const role = tone === "error" ? "alert" : "status";
  const classes = cn(
    "mt-[15px] w-full text-xs leading-5 [&_a]:font-medium [&_a]:text-blue-04 [&_a]:underline",
    className,
  );
  if (format === "html") {
    return (
      <SafeHtml
        as="div"
        role={role}
        html={message}
        className={classes}
        {...rest}
      />
    );
  }
  return (
    <div role={role} className={classes} {...rest}>
      {message}
    </div>
  );
}
